export default async function scrollBehavior(to, _from, savedPosition) {
    // dont scroll if path or hash dont  change
    if (to && _from && to.path === _from.path && to.hash === _from.hash) return

    if (savedPosition) {
        return savedPosition
    }

    const findEl = (hash, x = 0) => {
        return (
            document.querySelector(hash) ||
            new Promise((resolve) => {
                if (x > 70) {
                    return resolve(document.querySelector('#app'))
                }
                setTimeout(() => {
                    resolve(findEl(hash, ++x || 1))
                }, 100)
            })
        )
    }

    if (to.hash) {
        // window.location.hash = ''; // Peto: This does not work properly...

        const headerElement = document.querySelector('header.HeaderSticky')
        const headerHeight = headerElement ? headerElement.offsetHeight : 0

        const el = await findEl(to.hash)
        if (el && typeof el.offsetTop !== 'undefined') {
            const targetTop = Math.max(0, el.offsetTop - headerHeight)
            if ('scrollBehavior' in document.documentElement.style) {
                return window.scrollTo({
                    top: targetTop,
                    behavior: 'smooth'
                })
            } else {
                return window.scrollTo(0, targetTop)
            }
        }
    }

    return { x: 0, y: 0 }
}
